module.exports = __WEBPACK_EXTERNAL_MODULE_64__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"react-addons-transition-group","commonjs2":"react-addons-transition-group","amd":"react-addons-transition-group","root":["React","addons","TransitionGroup"]}
 ** module id = 64
 ** module chunks = 0
 **/